import React from "react";
import { useNavigate } from "react-router-dom";
import { SeeAllProviders } from "../../ui-components";
import { Flex, Heading, Button, Text, Card } from "@aws-amplify/ui-react";
import DoctorDetailsCard from "./DoctorDetailsCard";
import { useCareProvidersQuery } from "./api/useCareProvidersQuery";
import {
  useCareProvidersDeleteMutation,
  useCareProvidersPutMutation,
} from "./api/useCareProvidersMutation";
import { useUserQuery } from "../common/useUserQuery";

export default function HealthProvidersPage() {
  const navigate = useNavigate();
  const { data: userQueryData } = useUserQuery();
  const { data, isFetching } = useCareProvidersQuery(
    userQueryData?.patientUserId
  );
  const { mutate: careProvidersDeleteMutation } =
    useCareProvidersDeleteMutation();

  const { mutate: careProvidersPutMutation } = useCareProvidersPutMutation();

  const handleOnDelete = (id) => {
    careProvidersDeleteMutation(id);
  };

  const handleOnPrimaryProviderClick = (providerData) => {
    delete providerData.providerImageUrl; //deleting as this is not supported yet
    careProvidersPutMutation({ ...providerData, isPrimaryProvider: true });
  };

  return (
    <Flex
      direction="column"
      padding="12px"
      backgroundColor="rgba(250,250,250,1)"
    >
      <Flex direction="row" alignItems="center">
        <Heading level="1" children="Health Providers"></Heading>
        <Button
          size="small"
          variation="primary"
          onClick={() => navigate("/user/hr/health-providers/add")}
        >
          Add
        </Button>
      </Flex>
      <Flex direction="column">
        {isFetching ? (
          <>
            <Text>Loading...</Text>
          </>
        ) : (
          data?.map((healthCareProviders, index) => {
            return (
              <Flex key={`hcp_${healthCareProviders?.id}`}>
                <DoctorDetailsCard
                  overrides={{
                    EncountersAdd: {
                      onClick: () =>
                        navigate(
                          `/user/hr/encounter/${healthCareProviders?.id}/add`
                        ),
                    },
                    AppointmentAdd: {
                      onClick: () =>
                        navigate(
                          `/user/quick-actions/appointment-reminder/add?hcp=${healthCareProviders?.id}`
                        ),
                    },
                    DoctorImage: {
                      display: "none",
                    },
                    DoctorNameLabel: {
                      children: healthCareProviders?.providerName,
                    },
                    Specialty: {
                      children: healthCareProviders?.providerSpecialty,
                    },
                    SecondarySpecialty: {
                      children: healthCareProviders?.providerSubSpecialty,
                    },
                    AddedDate: {
                      children: `Added at: ${healthCareProviders?.createdAt}`,
                    },
                    LastSeenDate: {
                      children: `Last Seen:`,
                    },
                    TotalEncounters: {
                      children: `Encounters:`,
                    },
                    PrimaryCareProviderButton: {
                      onClick: handleOnPrimaryProviderClick.bind(
                        this,
                        healthCareProviders
                      ),
                      isDisabled:
                        healthCareProviders?.isPrimaryProvider === 1
                          ? true
                          : false,
                    },
                    ViewButton: {
                      onClick: () =>
                        navigate(
                          `/user/hr/health-providers/${healthCareProviders?.id}`
                        ),
                    },
                    EditButton: {
                      onClick: () =>
                        navigate(
                          `/user/hr/health-providers/${healthCareProviders?.id}/edit`
                        ),
                    },
                    DeleteButton: {
                      onClick: handleOnDelete.bind(
                        this,
                        healthCareProviders?.id
                      ),
                    },
                  }}
                />
              </Flex>
            );
          })
        )}
      </Flex>
    </Flex>
  );
}
